<template>
  <v-container fluid pa-3 background  class="contain_width">
    <v-layout row wrap >
      <!-- Create Button -->
      <v-flex md12 sm12 xs12 style="margin-top:100px;">
        <v-tooltip top>
          <v-btn
            slot="activator"
            color="primary"
            dark
            fixed
            bottom
            right
            fab
            @click="onHandleDialog(true, 'create', null)"
          >
            <v-icon>fa-plus</v-icon>
          </v-btn>
          <span>{{$t('create')}}</span>
        </v-tooltip>
      </v-flex>
      <v-layout
        row
        align-center
        text-xs-center
        style="margin-top:5rem;margin-bottom:15rem"
         v-if="table_data.length == 0 && !showLoading"
      >
        <v-flex xs12 md4 offset-md4 lg2 offset-lg5 class="adddoc-hover" style="cursor: pointer">
          <v-tooltip top>
            <template slot="activator">
              <div
                @click="onHandleDialog(true, 'create', null)"
                style="padding-top:40px;padding-bottom:40px;"
              >
                <v-icon style="font-size:80px;" color="blue">fa fa-plus</v-icon>
                <h3 class="headline mb-0" style="color:#2195F3;">{{$t('AddWorkPlan')}}</h3>
              </div>
            </template>
            <span>{{$t('ClickFor')}} {{$t('AddWorkPlan')}}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <!-- List -->
      <v-flex md12 sm12 xs12>
        <v-layout row wrap v-if="!showLoading">
          <v-flex md6 sm6 xs12 pa-1 v-for="(item, index) in table_data" :key="index" @click="''">
            <v-card class="coco-box-shadow coco-list-hover">
              <v-layout align-center justify-center row fill-height wrap class="coco-list-layout">
                <v-flex lg10 md8 sm8 xs12 pa-2>
                  <v-layout row wrap pa-2>
                    <v-flex xs12>
                      <span class="coco-list-label-text">{{isEmpty(item.code)? item.code : 'Code'}}:</span>
                      <span
                        v-html="' (<span style=color:#166BFF;>'+(isEmpty(item.name) ? item.name : 'Name')+'</span>)'"
                      />
                    </v-flex>
                    <v-flex md12 class="hidden-sm-and-down">
                      <span class="coco-list-label-icon" v-show="isEmpty(item.emp_code)">
                        <v-icon>fa-address-card</v-icon>
                        <span>{{item.emp_code}}</span>
                      </span>
                      <span class="coco-list-label-text">
                        {{$t('type')}}:
                        <span>{{item.plan_type == '0'? 'แผนตามช่วงเวลา' : 'แผนตามวันทำงาน'}}</span>
                      </span>
                    </v-flex>
                    <v-flex sm12 xs12 class="hidden-md-and-up">
                      <span
                        class="coco-list-label-icon hidden-xs-only"
                        v-show="(item.remark != '' && item.remark != undefined && item.remark != null)"
                      >
                        <v-icon>info</v-icon>
                        <span>{{item.remark}}</span>
                      </span>
                    </v-flex>
                    <v-flex xs12 class="hidden-sm-and-up">
                      <span
                        class="coco-list-label-icon"
                        v-show="(item.remark != '' && item.remark != undefined && item.remark != null)"
                      >
                        <v-icon>info</v-icon>
                        <span>{{item.remark}}</span>
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex lg2 md4 sm4 class="hidden-xs-only">
                  <v-layout row wrap>
                    <v-flex md12 sm12 xs12 text-xs-center>
                      <v-layout row wrap>
                        <v-flex offset-lg5 offset-md3 lg3 md4 xs6>
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="warning"
                              flat
                              icon
                              @click="onHandleDialog(true,'update',item)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <span>{{$t('edit')}}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex lg3 md4 xs6>
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="error"
                              flat
                              icon
                              @click="deleteItem(item)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                            <span>{{$t('delete')}}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="hidden-sm-and-up">
                  <v-layout row wrap>
                    <v-flex md12 sm12 xs12 text-xs-center>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="warning"
                              icon
                              flat
                              @click="onHandleDialog(true,'update',item)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <span>{{$t('edit')}}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs6>
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="error"
                              icon
                              flat
                              @click="deleteItem(item)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                            <span>{{$t('delete')}}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="coco-list-divider">
                  <v-divider/>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- Delete Dialog -->
      <v-flex md12 sm12 xs12>
        <v-dialog v-model="delDialogStatus" persistent max-width="300px" >
          <v-card>
            <v-toolbar dark color="blue d-1">
              <v-toolbar-title>
                <v-icon :size="20" class="px-2">fa-question-circle</v-icon>
                <span>{{$t('info.confirm_delete')}}</span>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text style="margin-top:30px;margin-bottom:10px;text-align: center;">ต้องการลบข้อมูล แผน:{{delDialog.name}} ใช่หรือไม่?</v-card-text>
            <v-card-actions>
              <v-layout row wrap>
                <v-flex xs6 pa-1>
                  <v-btn
                    color="error"
                    outline
                    block
                    @click="delDialogStatus = false"
                  >{{$t('cancel')}}</v-btn>
                </v-flex>
                <v-flex xs6 pa-1>
                  <v-btn color="success" outline block @click="onDelete()">{{$t('submit')}}</v-btn>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <!-- Frm Dialog -->
      <v-flex md12 sm12 xs12>
        <frm-dialog :json_data="dialog_data" v-on:close-dialog="onCloseDialog"/>
      </v-flex>
      <!-- Snackbar -->
      <v-snackbar
        v-model="snack_model.status"
        :timeout="3500"
        :top="'top'"
        :color="snack_model.type"
      >
        {{ snack_model.msg }}
        <v-btn dark flat icon @click="snack_model.status = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import SettingService from "@/services/SettingService";
import Utils from "@/utils/";
import FrmDialog from "./FormDialog";

export default {
  data: () => ({
    dialog_data: {
      status: false,
      save_type: String,
      data: Object
    },
    table_data: [],
    pageActive: 1,
    processing: false,
    canLoadMore: true,
    delDialogStatus: false,
    delDialog: {
      roworder: "",
      name: ""
    },
    snack_model: {
      status: "",
      msg: "",
      type: ""
    }
  }),
  created: function() {
    this.commitSetToolbar({
      patternTool: "0"
    });
    this.getProfileShiftList();
  },
  destroyed: function() {
    this.commitToggleAlertDialog({
      status: false,
      message: Object
    });
  },
  components: {
    FrmDialog
  },
  computed: {
    ...mapState("app", ["showLoading"])
  },
  methods: {
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    onCloseDialog() {
      this.pageActive = 1;
      this.table_data = [];
      this.dialog_data.status = false;
      this.getProfileShiftList();
    },
    onHandleDialog(status, save_type, data) {
      this.dialog_data = {
        status: status,
        save_type: save_type,
        data: data
      };
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    onScrollFunction(e) {
      let win_scroll_top = e.target.defaultView.pageYOffset;
      let win_height = window.innerHeight;
      let doc_height = document.body.scrollHeight;

      if (win_scroll_top >= (doc_height - win_height) * 0.99) {
        if (!this.processing && this.canLoadMore) {
          this.pageActive += 1;
          this.getExpensesList();
        }
      }
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    getProfileShiftList() {
      this.commitSetShowLoading(true);
      SettingService.getProfileAllPlan(this.pageActive)
        .then(res => {
          this.table_data = res.data.content;
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
    deleteItem(data) {
      this.delDialog.roworder = data.code;
      this.delDialog.name = data.name;
      this.delDialogStatus = true;
    },
    onDelete() {
      this.commitSetShowLoading(true);
      SettingService.deleteProfilePlan(this.delDialog.roworder)
        .then(res => {
          this.showSnackBar("delete success", "success");
          this.pageActive = 1;
          this.table_data = [];
          this.getProfileShiftList();
          this.delDialogStatus = false;
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    }
  }
};
</script>